export default __webpack_public_path__ + "static/media/order-down.4dc772af.svg";